import { useState } from "react";
import { SPELLS, getEffectiveSpellProps } from "@/app/spells";

export default function SpellSelection({ onSpellSelected }) {
  const [selectedSpell, setSelectedSpell] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSelectSpell = (spellId) => {
    if (isSubmitting) return; // Prevent selection changes while submitting
    setSelectedSpell(spellId);
  };

  const handleConfirm = () => {
    if (selectedSpell && !isSubmitting) {
      setIsSubmitting(true);
      onSpellSelected(selectedSpell);
    }
  };

  return (
    <div className="p-8 flex justify-center items-center min-h-screen">
      <div className="max-w-2xl">
        <h1 className="text-2xl font-bold mb-6 text-center">
          Choose Your Starting Spell
        </h1>
        <p className="text-slate-400 mb-8 text-center">
          Select one spell to unlock for free. You can purchase additional
          spells for 40 gold each later.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {Object.values(SPELLS).map((spell) => (
            <div
              key={spell.id}
              className={`p-6 rounded-lg border-2 cursor-pointer transition-all ${
                selectedSpell === spell.id
                  ? "border-amber-500 bg-amber-500/10"
                  : "border-slate-600 bg-slate-800 hover:border-slate-400"
              } ${isSubmitting ? "opacity-50 cursor-not-allowed" : ""}`}
              onClick={() => handleSelectSpell(spell.id)}
            >
              <div className="flex flex-col items-center">
                <img
                  src={`/spells/${spell.id.toLowerCase()}.png`}
                  alt={spell.name}
                  className="w-20 h-20 rounded-lg mb-4 object-cover"
                />
                <h3 className="text-lg font-bold mb-2">{spell.name}</h3>
                <p className="text-slate-400 text-sm text-center mb-3">
                  {spell.description}
                </p>
                <div className="text-xs text-slate-500">
                  {(() => {
                    const effective = getEffectiveSpellProps(spell.id, [
                      spell.id,
                    ]);
                    const cd =
                      typeof effective.cooldown === "number"
                        ? effective.cooldown
                        : 0;
                    return `Cooldown: ${cd} turn${cd !== 1 ? "s" : ""}`;
                  })()}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            className={`px-8 py-3 rounded-lg font-bold ${
              selectedSpell && !isSubmitting
                ? "bg-amber-500 text-black hover:bg-amber-400"
                : "bg-slate-600 text-slate-400 cursor-not-allowed"
            }`}
            onClick={handleConfirm}
            disabled={!selectedSpell || isSubmitting}
          >
            {isSubmitting ? "Creating Player..." : "Confirm Selection"}
          </button>
        </div>
      </div>
    </div>
  );
}
